module.exports = __webpack_public_path__ + "static/media/Robot Structural Analysis Professional.724fe434.png";